import { useEffect } from 'react';
import Pagination from '~components/atoms/Pagination';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

const StockOutApprovalPaginator = () => {
    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(state => state.approval.loadings.getPendingStockOutListing);
    const { index, maxIndex } = useAppSelector(state => state.approval.pendingStockOutListing);

    const setIndex = (newIndex: number) => {
        if (isLoading) return;
        dispatch(combinedActions.approvalSetPendingStockOutListingIndex({ index: newIndex }));
    };

    useEffect(() => {
        if (index > maxIndex) setIndex(0);
    }, [maxIndex]);

    const handleOnPrev = () => { if (index > 0) setIndex(index - 1); };
    const handleOnNext = () => { if (index < maxIndex) setIndex(index + 1); };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex);

    return (
        <Pagination
            currentPage={index}
            maxPage={maxIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default StockOutApprovalPaginator;
